import { useMemo } from 'react';

import { useStatusContext } from 'pages/Status/context';

import { getNovunaState } from './helpers';

import { LenderStatus } from '../constants';

interface NovunaStatusContentHook {
  state: LenderStatus;
}

export default function useNovunaStatusContent(): NovunaStatusContentHook {
  const { job, credit, deposit, isLoading } = useStatusContext();

  const state = useMemo((): LenderStatus => {
    if (isLoading || !job || !credit) return 'loading';
    return getNovunaState(job, credit, deposit);
  }, [job, credit, deposit, isLoading]);

  return {
    state,
  };
}
